import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Gift, Clock } from 'lucide-react';

const HERO_IMG =
  'https://images.unsplash.com/photo-1605919599445-cfe2c8bd7c50?crop=entropy&cs=srgb&fm=jpg&w=1920&q=80';

const HomeHero = () => {
  const navigate = useNavigate();
  return (
    <section
      data-testid="home-hero"
      className="relative h-[420px] sm:h-[480px] md:h-[540px] lg:h-[620px] bg-cover bg-center flex items-center"
      style={{
        backgroundImage: `linear-gradient(90deg, rgba(58,16,20,0.88) 0%, rgba(58,16,20,0.55) 55%, rgba(58,16,20,0.3) 100%), url(${HERO_IMG})`,
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-white w-full">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-xs sm:text-sm tracking-[3px] font-semibold" style={{ color: '#FDB913' }}>
            🎁 HOLIDAY GIFTING
          </p>
          <h1 className="mt-3 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] drop-shadow-lg" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
            Custom-wine gifts for Christmas &amp; New Year
          </h1>
          <p className="mt-4 text-base sm:text-lg md:text-xl opacity-95 max-w-xl">
            Put a favourite photo on a custom holiday wine label — a one-of-a-kind present ready to unwrap.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold" style={{ background: '#FFFBEA', color: '#8a5a00' }} data-testid="home-hero-deadline">
            <Clock className="w-4 h-4" /> Order by Nov 15 for Christmas
          </div>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button
              asChild
              size="lg"
              data-testid="hero-gift-cta-btn"
              className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6"
            >
              <Link to="/holiday-gifting"><Gift className="w-5 h-5 mr-2" /> Request your gift</Link>
            </Button>
            <Button
              size="lg"
              variant="outline"
              data-testid="hero-browse-wines-btn"
              className="bg-white text-gray-900 hover:bg-gray-100 border-2 border-white text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6"
              onClick={() => navigate('/wines')}
            >
              Browse Our Wines
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
